module.exports = __webpack_public_path__ + "static/media/logo-1.5330e279.svg";